module.exports = __webpack_public_path__ + "img/left_kv.96f5f496.svg";